import { TrendingUp, Info, Lock } from "lucide-react";
import { Section, Stat } from "@/components/plan/common";

export default function PlanningScenarios({ scenarios, assumptions, scenario, setScenario, isFree }) {
  if (!scenarios) return null;
  return (
    <Section icon={TrendingUp} title="Planning scenarios"
      subtitle="Illustrative outcomes based on industry benchmark assumptions — not guaranteed results.">
      <div className="flex gap-2 mb-4 no-print" data-testid="scenario-tabs">
        {["conservative", "expected", "strong"].map((s) => {
          const locked = isFree && s !== "conservative";
          return (
            <button
              key={s}
              data-testid={`scenario-${s}`}
              onClick={() => !locked && setScenario(s)}
              className={`px-4 h-10 rounded-full text-sm font-medium capitalize transition-colors ${
                scenario === s ? "bg-zinc-900 text-white" : "bg-white border border-zinc-200 text-zinc-700 hover:border-zinc-400"
              } ${locked ? "opacity-60" : ""}`}
            >
              {s} {locked && <Lock className="inline h-3 w-3 ml-1" />}
            </button>
          );
        })}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {["conservative", "expected", "strong"].map((s) => {
          const sc = scenarios[s];
          if (!sc) return null;
          const locked = isFree && s !== "conservative";
          const active = scenario === s;
          return (
            <div key={s}
              className={`relative bg-white border rounded-2xl p-6 ${
                active ? "border-indigo-600 shadow-lg shadow-indigo-100" : "border-zinc-200"
              }`}
            >
              {locked && (
                <div className="absolute inset-0 backdrop-blur-sm bg-white/60 rounded-2xl flex items-center justify-center">
                  <div className="bg-white border border-zinc-200 rounded-full px-4 py-2 shadow-sm inline-flex items-center gap-2 text-xs">
                    <Lock className="h-3.5 w-3.5 text-indigo-600" /> Unlock in Pro
                  </div>
                </div>
              )}
              <div className="text-xs uppercase tracking-widest text-zinc-500 capitalize">{s} scenario</div>
              <div className="mt-3">
                <div className="text-xs text-zinc-500">Leads / month</div>
                <div className="font-display font-black text-3xl text-zinc-900">{sc.leads_range}</div>
              </div>
              <div className="mt-3">
                <div className="text-xs text-zinc-500">Cost per lead (est.)</div>
                <div className="font-display font-black text-xl text-indigo-700">₹{sc.cpl_range_inr}</div>
              </div>
              <div className="mt-3 text-xs text-zinc-500">Spend: ₹{Number(sc.spend_inr).toLocaleString("en-IN")}</div>
              <div className="mt-4 border-t border-zinc-100 pt-3">
                <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-1.5">Assumptions</div>
                <ul className="text-xs space-y-1 text-zinc-700">
                  {sc.key_assumptions?.map((a, i) => <li key={`assum-${i}-${a}`}>• {a}</li>)}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
      {assumptions && (
        <div className="mt-5 bg-zinc-100 rounded-2xl p-5 text-sm text-zinc-700">
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-500 mb-2">
            <Info className="h-3.5 w-3.5" /> Baseline benchmark ranges
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Stat label="CPC (INR)" val={assumptions.avg_cpc_inr} />
            <Stat label="Landing CVR" val={`${assumptions.landing_page_cvr_percent}%`} />
            <Stat label="CTR" val={`${assumptions.ctr_percent}%`} />
          </div>
          {assumptions.notes && <p className="text-xs text-zinc-500 mt-3">{assumptions.notes}</p>}
        </div>
      )}
    </Section>
  );
}
